<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start" class="ion-no-padding ion-no-margin">
      <ion-menu-button></ion-menu-button>
      <ion-button routerLink="/" routerDirection="root">
        <div class="logo-container">
          <img
            class="logo-maennchen-headshot"
            src="/assets/img/logo-maennchen-headshot.png"
            height="30"
            width="30"
          />
          <img class="logo-nur-schrift" src="/assets/img/logo-nur-schrift.png" height="30" />
        </div>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end" class="ion-no-padding ion-no-margin">
      <ion-menu-toggle>
        <ion-button id="logout" matTooltip="Logout" (click)="logout()">
          <ion-icon name="log-out"></ion-icon>
        </ion-button>
      </ion-menu-toggle>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-list>
  <ion-menu-toggle>
    <ion-item
      routerLink="/profile"
      lines="full"
      routerLinkActive
      #profile="routerLinkActive"
      [color]="profile.isActive ? 'primary' : ''"
    >
      <ion-icon name="person-circle" slot="end"></ion-icon>
      <ion-label>Mein Profil</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle>
    <ion-item
      routerLink="/order"
      lines="full"
      routerLinkActive
      #order="routerLinkActive"
      [color]="order.isActive ? 'primary' : ''"
    >
      <ion-icon name="document-text" slot="end"></ion-icon>
      <ion-label>Bestellungen</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle>
    <ion-item
      routerLink="/customer"
      lines="full"
      routerLinkActive
      #customer="routerLinkActive"
      [color]="customer.isActive ? 'primary' : ''"
    >
      <ion-icon name="people" slot="end"></ion-icon>
      <ion-label>Kunden</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle>
    <ion-item
      routerLink="/discount"
      routerLinkActive
      lines="full"
      #discount="routerLinkActive"
      [color]="discount.isActive ? 'primary' : ''"
    >
      <ion-icon name="pricetags" slot="end"></ion-icon>
      <ion-label>Discounts</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle>
    <ion-item
      routerLink="/trips"
      routerLinkActive
      lines="full"
      #calendar="routerLinkActive"
      [color]="calendar.isActive ? 'primary' : ''"
    >
      <ion-icon name="calendar" slot="end"></ion-icon>
      <ion-label>Termine</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-list-header> CMS </ion-list-header>
  <ion-menu-toggle>
    <ion-item
      routerLink="/camp"
      routerLinkActive
      lines="full"
      #camp="routerLinkActive"
      [color]="camp.isActive ? 'primary' : ''"
    >
      <ion-icon name="bonfire" slot="end"></ion-icon>
      <ion-label>Camps</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle>
    <ion-item
      routerLink="/category"
      routerLinkActive
      lines="full"
      #category="routerLinkActive"
      [color]="category.isActive ? 'primary' : ''"
    >
      <ion-icon name="pricetags" slot="end"></ion-icon>
      <ion-label>Kategorien</ion-label>
    </ion-item>
  </ion-menu-toggle>
  <ion-menu-toggle>
    <ion-item
      routerLink="/gallery"
      routerLinkActive
      lines="full"
      #gallery="routerLinkActive"
      [color]="gallery.isActive ? 'primary' : ''"
    >
      <ion-icon name="grid" slot="end"></ion-icon>
      <ion-label>Galerien</ion-label>
    </ion-item>
  </ion-menu-toggle>

  <ion-menu-toggle>
    <ion-item
      routerLink="/blog"
      routerLinkActive
      lines="full"
      #blog="routerLinkActive"
      [color]="blog.isActive ? 'primary' : ''"
    >
      <ion-icon name="book" slot="end"></ion-icon>
      <ion-label>Blog</ion-label>
    </ion-item>
  </ion-menu-toggle>

  <ion-menu-toggle>
    <ion-item
      routerLink="/faq"
      routerLinkActive
      lines="full"
      #faq="routerLinkActive"
      [color]="faq.isActive ? 'primary' : ''"
    >
      <ion-icon name="help-circle" slot="end"></ion-icon>
      <ion-label>FAQ</ion-label>
    </ion-item>
  </ion-menu-toggle>

  <ion-menu-toggle>
    <ion-item
      routerLink="/image"
      routerLinkActive
      lines="full"
      #image="routerLinkActive"
      [color]="image.isActive ? 'primary' : ''"
    >
      <ion-icon name="images" slot="end"></ion-icon>
      <ion-label>Bilder</ion-label>
    </ion-item>
  </ion-menu-toggle>
</ion-list>
